import type { Model, Slicer } from '../../types';

export interface ConfigState {
  apiDomain?: string;
  marketingApiBasePath?: string;
  pokerApiDomain?: string;
  gtmAuth?: string;
  gtmId?: string;
  gtmPreview?: string;
  idpClientUrl?: string;
  mttDataType?: string;
  requestTimeout?: number;
  salesforceAuthSdk?: string;
  salesforceDeploymentCode?: string;
  salesforceDeploymentNameAuthenticated?: string;
  salesforceDeploymentNameUnauthenticated?: string;
  salesforceScrt?: string;
  salesforceSrcAuthenticated?: string;
  salesforceSrcUnauthenticated?: string;
  salesforceUnauthSdk?: string;
  sentryDsn?: string;
  sentryEnvironment?: string;
  sentryErrorReplaySampleRate?: number;
  sentrySampleRate?: number;
  sentrySampleRatePrHub?: number;
  trackingId?: string;
  wsSockJsTimeout?: number;
  casinoappDomainSource?: 'parent' | 'resolver';
  ffFetchMode?: string;
  incodeUrl?: string;
  incodeConsentId?: string;
}

const defaultState: ConfigState = { requestTimeout: 20000 };

export const keys = Object.keys(defaultState);

const reducers = {
  set: (state: ConfigState, payload: ConfigState = {}) => ({ ...state, ...payload })
};

const selectors = (slice: Slicer<ConfigState>) => ({
  get() {
    return slice;
  }
});

const config: Model<ConfigState, typeof reducers, void, void, typeof selectors> = {
  state: defaultState,
  reducers,
  selectors
};

export default config;
